import ILocation from "../types/ILocation";

export const hasRequiredRailStationAndCarriers = (
  location: Pick<ILocation, "inboundModes" | "outboundModes" | "stationState" | "carriers">,
): boolean => {
  const railIsActive =
    location.inboundModes?.includes("RAIL") ||
    location.outboundModes?.includes("RAIL");

  return (
    !railIsActive ||
    (Boolean(location.stationState) && location.carriers.length > 0)
  );
};